import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, notification, Select, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import { compact, get } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import CloseModal from "../../../components/icons/CloseModal";
import { sonyClientPublishField } from "../../../config/index";
import { calculateActualDuration, stringToSeconds } from "../../../constants/phase";
import amplitude from "../../../externals/amplitude";
import { CMSValidation } from "../../../utils/validations";
const { Option } = Select;

const PublishToCMS = (props) => {
  const {
    publishToCMS,
    setPublishTOCMS,
    editClip,
    clip,
    publishClips,
    clientWebHookPublish,
    allClips,
    singleClipDetail,
    streamDetails,
    filters,
    getCustomFields,
  } = props;
  const closeModal = () => {
    setPublishTOCMS(false);
  };

  const { clientSetting, entityId } = useOutletContext();
  const [singleClip, setSingleClip] = useState({});
  const [loader, setLoader] = useState(false);
  const [cmsIdError, setCmsIdError] = useState(false);
  const [isPublish, setIsPublish] = useState(false);
  const [isReelPublish, setIsReelPublish] = useState(false);
  const [initialState, setInitialState] = useState({});
  const [customFields, setCustomFields] = useState([]);

  const fetchCustomFields = async () => {
    const { value } = await getCustomFields({
      entityId: entityId,
    });
    if (value.success) {
      const customField = value?.setting?.customFields?.filter((bt) => bt?.formType === "clip-tagging");
      console.log({
        customField,
      });
      setCustomFields(customField);
    }
  };
  useEffect(() => {
    fetchCustomFields();
  }, [entityId]);

  const updateData = async () => {
    const seoObject = { seoTitle: initialState.seoTitle, seoDescription: initialState.seoDescription };
    const payload = {
      ...initialState,
      episodeTitle: initialState.title,
      tlmMarker: stringToSeconds(initialState?.tlmMarker),
      tags: Array.isArray(initialState?.tags)
        ? initialState?.tags
        : compact((initialState?.tags || "")?.split(",")?.map((tag) => tag?.trim())),
      id: clip.id,
      _id: clip._id,
      entityId,
      seoObject,
    };
    delete payload.title;
    delete payload.seoDescription;
    delete payload.seoTitle;
    const data = await editClip(payload);
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      getSingleClipDetails();
    } else {
      notification["error"]({ message: "something went wrong" });
    }
  };

  const publishFun = async () => {
    await publishClips({
      id: clip.id,
      title: clip.episodeTitle,
      storageName: "",
      clipsAspectRatio: filters?.aspectRatio || clip.aspectRatio,
    });
    amplitude.logEvent("cms_clip_published", {
      isDynamic: false,
    });
    setLoader(false);
    closeModal();
  };

  const publishClipToCMS = async () => {
    if (!initialState.cmsId) {
      setCmsIdError(true);
      return;
    }
    setLoader(true);
    if (clientSetting?.permissions?.dynamicCms) {
      webHookPublish();
    } else {
      publishFun();
    }
  };
  const webHookPublish = async () => {
    const data = await clientWebHookPublish({
      clipId: singleClip.id,
      entityId,
      cmsId: initialState.cmsId,
      streamId: clip.streamId,
      isPublish: isPublish ? 0 : 1,
      isReel: isReelPublish,
      mediaCategory: initialState?.mediaCategory || "",
      clipsAspectRatio: filters?.aspectRatio || clip.aspectRatio,
    });
    if (data.value.success) {
      allClips();

      amplitude.logEvent("cms_clip_published", {
        isDynamic: true,
      });
      notification["success"]({ message: data.value.message });
    } else {
      notification["error"]({ message: data.value.message });
    }
    setLoader(false);
    closeModal();
  };
  const handleChange = (name, value) => {
    setInitialState({
      ...initialState,
      [name]: value,
    });
  };
  const getSingleClipDetails = async () => {
    const data = await singleClipDetail({
      id: clip?._id,
    });
    if (data?.value?.success) {
      setSingleClip(data?.value?.data);
    }
  };

  useEffect(() => {
    if (clip) getSingleClipDetails();
  }, [clip]);

  const setInitialValue = useCallback(() => {
    if (clientSetting && streamDetails && clip) {
      let initialStateData = {
        cmsId: clientSetting?.webhook?.clientWebHookURLs?.[0]?.id || "",
        title: clip?.episodeTitle,
        tlmMarker: clip?.tlmMarker
          ? moment.utc(clip?.tlmMarker * 1000).format("HH:mm:ss")
          : calculateActualDuration(streamDetails, clip),
      };
      if (sonyClientPublishField && streamDetails && clip && clientSetting?.permissions?.sonyFeed) {
        sonyClientPublishField.forEach((data) => {
          initialStateData[`${data.name}`] =
            get(clip, `${data.name}`, "") ||
            get(clip, `${data.defaultValue}`, "") ||
            get(streamDetails, `${data.defaultValue}`, "");
        });
      }
      setInitialState(initialStateData);
    }
  }, [clientSetting, streamDetails, clip]);

  useEffect(() => {
    setInitialValue();
  }, [setInitialValue]);

  return (
    <div>
      <Modal
        isOpen={publishToCMS}
        onRequestClose={closeModal}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        contentLabel="Publish to CMS"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-sm modal-dialog-centered filter-modal"
      >
        <Formik initialValues={initialState} enableReinitialize validationSchema={CMSValidation} onSubmit={updateData}>
          {({ errors, touched, values }) => (
            <div className="modal-content">
              <Form>
                <div className="react-modal-header">
                  <h5 className="react-modal-title">
                    Publish to CMS <span>{clip?.id}</span>
                  </h5>
                  <button type="button" onClick={closeModal} className="btn btn__default">
                    <CloseModal />
                  </button>
                </div>
                <div className="react-modal-body">
                  <div className="form-container inlinebtn-row">
                    <div className="form-group">
                      <label className="form-label">
                        CMS <span className="required">{"*"}</span>
                      </label>
                      <Select
                        showSearch
                        placeholder="select"
                        optionFilterProp="children"
                        className="custom-ant-select"
                        style={{ textTransform: "capitalize" }}
                        name="cmsId"
                        onChange={(e) => {
                          if (e) {
                            setCmsIdError(false);
                          } else {
                            setCmsIdError(true);
                          }
                          setInitialState({ ...initialState, cmsId: e });
                        }}
                        value={values.cmsId}
                      >
                        <Option value="">Select</Option>
                        {clientSetting?.webhook?.clientWebHookURLs?.length &&
                          clientSetting?.webhook?.clientWebHookURLs.map((webhook, index) => {
                            return (
                              <Option value={webhook?.id} key={index}>
                                {webhook?.name.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())}
                              </Option>
                            );
                          })}
                      </Select>
                      {cmsIdError && <div className="invalid-feedback">Required</div>}
                    </div>
                    <div className="row">
                      <div className="three-column-row">
                        <div className="form-group">
                          <label className="form-label">
                            Title <span className="required">*</span>
                          </label>
                          <Field
                            className="form-control"
                            name="title"
                            type="text"
                            placeholder="Enter title"
                            value={initialState.title}
                            onChange={(e) => {
                              setInitialState({
                                ...initialState,
                                title: e.target.value,
                              });
                            }}
                          />
                          {touched.title && errors.title && <div className="invalid-feedback">{errors.title}</div>}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            Time Line Marker <span className="required">*</span>
                          </label>
                          <Field
                            className="form-control"
                            name="tlmMarker"
                            type="text"
                            placeholder="hh:mm:ss"
                            value={initialState.tlmMarker}
                            onChange={(e) => {
                              setInitialState({
                                ...initialState,
                                tlmMarker: e.target.value,
                              });
                            }}
                          />
                          {touched.tlmMarker && errors.tlmMarker && (
                            <div className="invalid-feedback">{errors.tlmMarker}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    {customFields &&
                      customFields.map((field, index) => {
                        if (field?.fieldType === "input") {
                          return (
                            <div className="form-group" key={field.id}>
                              <label className="form-label title_Pascal">
                                {field?.inputFieldLabel}{" "}
                                {field?.isRequired ? <span className="required">{"*"}</span> : null}
                              </label>
                              <Field
                                name={field.inputFieldName}
                                type="text"
                                placeholder={get(field, "inputPlaceholderTitle", "")}
                                className="form-control"
                                defaultValue={get(field, "defaultValue", "")}
                                onChange={(e) => {
                                  const name = field?.inputFieldName;
                                  const value = e.target.value;
                                  handleChange(name, value);
                                }}
                                value={get(initialState, `${field.inputFieldName}`, field?.defaultValue)}
                                disabled={field?.isDisabled || isReelPublish || false}
                              />
                            </div>
                          );
                        } else if (field?.fieldType === "select") {
                          return (
                            <div className="form-group" key={field.id}>
                              <label className="form-label">
                                {field?.inputFieldLabel}{" "}
                                {field?.isRequired ? <span className="required">{"*"}</span> : null}
                              </label>
                              <Select
                                showSearch
                                placeholder={get(field, "inputPlaceholderTitle", field.inputFieldLabel)}
                                optionFilterProp="children"
                                className="custom-ant-select"
                                defaultValue={field?.defaultValue}
                                name={field?.inputFieldName}
                                onChange={(e) => {
                                  const name = field?.inputFieldName;
                                  const value = e;
                                  handleChange(name, value);
                                }}
                                value={get(initialState, `${field.inputFieldName}`, field?.defaultValue)}
                                disabled={field?.isDisabled || isReelPublish || false}
                              >
                                {field &&
                                  field?.selectoption.length &&
                                  field?.selectoption.map((option, idx) => {
                                    return (
                                      <Option value={option} key={idx}>
                                        {option}
                                      </Option>
                                    );
                                  })}
                              </Select>
                            </div>
                          );
                        } else if (field?.fieldType === "input-masking") {
                          return (
                            <div className="form-group" key={field.id}>
                              <label className="form-label title_Pascal">
                                {field?.inputFieldLabel}{" "}
                                {field?.isRequired ? <span className="required">{"*"}</span> : null}
                              </label>
                              <InputMask
                                name={field.inputFieldName}
                                type="text"
                                placeholder={get(field, "inputPlaceholderTitle", "")}
                                className="form-control"
                                defaultValue={get(field, "defaultValue", "")}
                                onChange={(e) => {
                                  const name = field?.inputFieldName;
                                  const value = e.target.value;
                                  handleChange(name, value);
                                }}
                                value={get(initialState, `${field.inputFieldName}`, field?.defaultValue)}
                                disabled={field?.isDisabled || isReelPublish || false}
                                mask={field?.inputMasking}
                              />
                            </div>
                          );
                        }
                      })}
                    <div className="row">
                      <div className="three-column-row">
                        <div className="form-group">
                          <label className="form-label">Draft Publish</label>
                          <div className="">
                            <Checkbox
                              value={isPublish}
                              onChange={(e) => {
                                setIsPublish(e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label">Reel Publish</label>
                          <div className="">
                            <Checkbox
                              value={isReelPublish}
                              onChange={(e) => {
                                setIsReelPublish(e.target.checked);
                                handleChange("mediaCategory", "");
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {clientSetting?.permissions?.sonyFeed && (
                      <div className="">
                        {sonyClientPublishField &&
                          sonyClientPublishField.map((data, index) => {
                            return (
                              <div className="mt-4" key={index}>
                                <div className="form-group">
                                  <label className="form-label">{data.heading}</label>

                                  {data.type === "dropdown" ? (
                                    // Render a dropdown if data.type is "dropdown"
                                    <Field
                                      as="select"
                                      className="form-control"
                                      name={data.name}
                                      defaultValue={
                                        get(clip, `${data.defaultValue}`, "") ||
                                        get(streamDetails, `${data.defaultValue}`, "")
                                      }
                                      onChange={(e) => {
                                        setInitialState({
                                          ...initialState,
                                          [`${data.name}`]: e.target.value,
                                        });
                                      }}
                                    >
                                      {data.options &&
                                        data.options.map((option) => (
                                          <option key={option.value} value={option.value}>
                                            {option.label}
                                          </option>
                                        ))}
                                    </Field>
                                  ) : (
                                    // Render a text input by default
                                    <Field
                                      className="form-control"
                                      name={data.name}
                                      type="text"
                                      placeholder={`Enter ${data.heading}`}
                                      defaultValue={
                                        get(clip, `${data.defaultValue}`, "") ||
                                        get(streamDetails, `${data.defaultValue}`, "")
                                      }
                                      onChange={(e) => {
                                        setInitialState({
                                          ...initialState,
                                          [`${data.name}`]: e.target.value,
                                        });
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-end">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Update
                      </button>
                      <>
                        <button
                          disabled={singleClip?.episodeTitle === "" || singleClip?.start_time === "" ? true : false}
                          className="btn btn-primary"
                          type="button"
                          onClick={publishClipToCMS}
                        >
                          Publish to CMS
                          {loader && (
                            <Spin
                              size="large"
                              indicator={
                                <LoadingOutlined
                                  style={{
                                    fontSize: 50,
                                    color: "#000",
                                    marginLeft: 50,
                                  }}
                                  spin
                                />
                              }
                              className="loader__full"
                            ></Spin>
                          )}
                        </button>
                      </>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default PublishToCMS;
